import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, map, Subject, take, takeUntil } from 'rxjs';
import { setFilterTerm } from '../state/toc.actions';
import { Store } from '@ngrx/store';
import { selectFilterTerm } from '../state/toc.selectors';
import { MatInput } from '@angular/material/input';
import { AutoFocusDirective } from '@tailormap-viewer/shared';

@Component({
    selector: 'tm-toc-filter-input',
    templateUrl: './toc-filter-input.component.html',
    styleUrls: ['./toc-filter-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatInput,
        ReactiveFormsModule,
        AutoFocusDirective,
    ],
})
export class TocFilterInputComponent implements OnInit, OnDestroy {
  private store$ = inject(Store);


  public filterControl = new FormControl<string>('', { nonNullable: true });

  private destroyed = new Subject();

  public ngOnDestroy() {
    this.destroyed.next(null);
    this.destroyed.complete();
  }

  public ngOnInit(): void {
    this.store$.select(selectFilterTerm).pipe(
      take(1),
    ).subscribe(filterTerm => this.filterControl.setValue(filterTerm || ''));

    this.filterControl.valueChanges.pipe(
      takeUntil(this.destroyed),
      debounceTime(200),
      map(filterTerm => filterTerm.trim() === '' ? undefined : filterTerm),
    ).subscribe(filterTerm => this.store$.dispatch(setFilterTerm({ filterTerm })));
  }
}
